/**
 * TicketedEventAudience — role-audience vocabulary for event collections.
 *
 * A deliberately NEW, first-class persona vocabulary (plan KTD4). It is
 * semantically disjoint from `SchoolEventAudienceScopeSchema` (event
 * provenance/scope: school_wide / section / community_group / activity) and is
 * NOT reconciled with it. These tags are metadata-only visibility hints with no
 * server-side access enforcement this release (R19/R20).
 */

import { z } from 'zod'

export const TicketedEventAudienceSchema = z.enum(['parent', 'faculty', 'staff', 'student', 'public'])
export type TicketedEventAudience = z.infer<typeof TicketedEventAudienceSchema>

/** A de-duplicated set of audience tags on a collection (order-insensitive). */
export const TicketedEventAudienceSetSchema = z.array(TicketedEventAudienceSchema)
export type TicketedEventAudienceSet = z.infer<typeof TicketedEventAudienceSetSchema>
